import React from 'react';
import clsx from 'clsx';
import { HeaderDataItem } from '@interfaces/models/header';
import Link from '@components/atoms/link/link';

import styles from '../main-navigation.module.scss';

interface NavigationProps {
  headerDataItem: HeaderDataItem;
  level?: number;
  onClick: (label: string) => void;
}

interface HighlightLink {
  id: number;
  tag: string;
}

const NavigationItem: React.FC<NavigationProps> = ({ headerDataItem, level = 1, onClick }) => {
  // Array of ids for which tags need to be displayed
  const highlightedLinkIds: HighlightLink[] = [{ id: 1057, tag: 'All brands' }];

  // Check if current like needs to be highlighted
  const highlightedLink: HighlightLink | undefined = highlightedLinkIds.find(
    (highlightLink: HighlightLink) => highlightLink.id === headerDataItem.id,
  );

  const isHighlighted: boolean = !!highlightedLink;

  return (
    <Link
      href={headerDataItem.url.seo}
      tabIndex={0}
      data-level={level}
      {...(isHighlighted && { 'data-tag': highlightedLink.tag })}
      className={clsx({ [styles.highlighted]: isHighlighted })}
      onClick={() => onClick(headerDataItem.localizedName)}
      data-cy={`navMenuItemLink-${headerDataItem.id}`}
    >
      {/* We need the span to make sure styling works correctly on highlighted items */}
      {isHighlighted ? <span>{headerDataItem.localizedName}</span> : <>{headerDataItem.localizedName}</>}
    </Link>
  );
};

export default NavigationItem;
